import React from "react";
class Toptho extends React.Component<any, any> {
    render(): React.ReactNode {
        return (
            <div className="product">
			<h2 id="6" className="product-title">TOP THỢ CẮT TRONG THÁNG</h2>
			<div className="product-title-2">Đội ngũ Stylist dày dặn kinh nghiệm</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="toptho-item">
					<img className="toptho-pic" alt = "none" src="img/toptho/1.jpg" /> <br /><br />
					<a href="none" className="sao-name">Hiếu Ngô</a><br />
					<span className="sao-mota">641 Cách Mạng Tháng 8, Bình Dương</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="toptho-item">
					<img className="toptho-pic" alt = "none" src="img/toptho/2.jpg" /> <br /><br />
					<a href="none" className="sao-name">Duy Lê</a><br />
					<span className="sao-mota">29 Hiệp Bình, HCM</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="toptho-item">
					<img className="toptho-pic" alt = "none" src="img/toptho/3.jpg" /> <br /><br />
					<a href="none" className="sao-name">Tú Nguyễn</a><br />
					<span className="sao-mota">29 Hiệp Bình, HCM</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="toptho-item">
					<img className="toptho-pic" alt = "none" src="img/toptho/4.jpg" /> <br /><br />
					<a href="none" className="sao-name">Lương Vũ</a><br />
					<span className="sao-mota">80 Trần Phú, Thanh Hóa</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="toptho-item">
					<img className="toptho-pic" alt = "none" src="img/toptho/5.jpg" /> <br /><br />
					<a href="none" className="sao-name">Giang Cao</a><br />
					<span className="sao-mota">641 Cách Mạng Tháng 8, Bình Dương</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="toptho-item">
					<img className="toptho-pic" alt = "none" src="img/toptho/6.jpg" /> <br /><br />
					<a href="none" className="sao-name">Đức Nguyễn</a><br />
					<span className="sao-mota">641 Cách Mạng Tháng 8, Bình Dương</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="toptho-item">
					<img className="toptho-pic" alt = "none" src="img/toptho/7.jpg" /> <br /><br />
					<a href="none" className="sao-name">Hải Nguyễn</a><br />
					<span className="sao-mota">177 Đặng Văn Bi, HCM</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="toptho-item">
					<img className="toptho-pic" alt = "none" src="img/toptho/8.jpg" /> <br /><br />
					<a href="none" className="sao-name">Phong Nguyễn</a><br />
					<span className="sao-mota">8 Châu Văn Liêm, HCM</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="toptho-item">
					<img className="toptho-pic" alt = "none" src="img/toptho/9.jpg" /> <br /><br />
					<a href="none" className="sao-name">Đang Nguyễn</a><br />
					<span className="sao-mota">177 Đặng Văn Bi, HCM</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="toptho-item">
					<img className="toptho-pic" alt = "none" src="img/toptho/10.jpg" /> <br /><br />
					<a href="none" className="sao-name">Nhân Huỳnh</a><br />
					<span className="sao-mota">112 Phổ Quang, HCM</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="toptho-item">
					<img className="toptho-pic" alt = "none" src="img/toptho/11.jpg" /> <br /><br />
					<a href="none" className="sao-name">Thư Đoái</a><br />
					<span className="sao-mota">36 đường N1, KCN Mỹ Phước 1, Bình Dương</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="toptho-item">
					<img className="toptho-pic" alt = "none" src="img/toptho/12.jpg" /> <br /><br />
					<a href="none" className="sao-name">Long Nguyễn</a><br />
					<span className="sao-mota">8 Châu Văn Liêm, HCM</span>
				</div>
			</div>

			<div className="clear"></div>
			<h2 id="6" className="product-title">30Shine’s Angels</h2>
			<div className="product-title-2">Đội ngũ Skinner xinh đẹp hết lòng vì khách hàng</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="angels-item">
					<a href="https://www.tiktok.com/@tu_quyen1401"><img className="angels-pic" alt = "none" src="img/angels/1.jpg" />
						<br /><br /></a>
					<span className="sao-mota">36 Nguyễn Ảnh Thủ, Quận 12, TP HCM</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="angels-item">
					<a href="https://www.tiktok.com/@tu_quyen1401"><img className="angels-pic" alt = "none" src="img/angels/3.jpg" />
						<br /><br /></a>
					<span className="sao-mota">1361 Phạm Văn Thuận, Phường Thống Nhất, TP. Biên Hoà</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="angels-item">
					<a href="https://www.tiktok.com/@tu_quyen1401"><img className="angels-pic" alt = "none" src="img/angels/4.jpg" />
						<br /><br /></a>
					<span className="sao-mota">12 Lê Đức Thọ, Q.Gò Vấp, TP. HCM</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="angels-item">
					<a href="https://www.tiktok.com/@tu_quyen1401"><img className="angels-pic" alt = "none" src="img/angels/5.jpg" />
						<br /><br /></a>
					<span className="sao-mota">99 Tân Sơn Nhì, Q.Tân Phú, TP. HCM</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="angels-item">
					<a href="https://www.tiktok.com/@tu_quyen1401"><img className="angels-pic" alt = "none" src="img/angels/6.jpg" />
						<br /><br /></a>
					<span className="sao-mota">4255 Nguyễn An Ninh, Phường Dĩ An, Bình Dương</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="angels-item">
					<a href="https://www.tiktok.com/@nhatmen0927"><img className="angels-pic" alt = "none" src="img/angels/7.jpg" />
						<br /><br /></a>
					<span className="sao-mota">955 Trần Hưng Đạo, Quận 5, TP.HCM</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="angels-item">
					<a href="https://www.tiktok.com/@tu_quyen1401"><img className="angels-pic" alt = "none" src="img/angels/8.jpg" />
						<br /><br /></a>
					<span className="sao-mota">408 Nguyễn Thị Thập, Quận 7, TP.HCM</span>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="angels-item">
					<a href="https://www.tiktok.com/@tu_quyen1401"><img className="angels-pic" alt = "none" src="img/angels/10.jpg" />
						<br /><br /></a>
					<span className="sao-mota">147 Lê Hồng Phong, Đắk Lắk</span>
				</div>
			</div>
			<div className="clear"></div>

			<h2 id="timmap" className="product-title">TÌM 30SHINE GẦN NHẤT</h2>
			<div className="product-title-2">Để xe thuận tiện an toàn, bản đồ dẫn đường chi tiết (hàng trăm Salon)</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="diadiem-item">
					<img className="tintuc-pic" title="diadiem1" alt = "none" src="img/diadiem/hanoi.png" /> <br /><br />
					<a href="none" className="diadiem-name">HÀ NỘI</a>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="diadiem-item">
					<img className="tintuc-pic" title="diadiem2" alt = "none" src="img/diadiem/hochiminh.jpg" /> <br /><br />
					<a href="none" className="diadiem-name">HỒ CHÍ MINH</a>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="diadiem-item">
					<img className="tintuc-pic" title="diadiem2" alt = "none" src="img/diadiem/danang.jpg" /> <br /><br />
					<a href="none" className="diadiem-name">ĐÀ NẴNG</a>
				</div>
			</div>
			<div className="col-s-6 col-m-4 col-x-3">
				<div className="diadiem-item">
					<img className="tintuc-pic" title="diadiem2" alt = "none" src="img/diadiem/hungyen.jpg" /> <br /><br />
					<a href="none" className="diadiem-name">ĐỊA ĐIỂM KHÁC</a>
				</div>
			</div>

			<div id="map" className="col-s-6 col-m-4 col-x-3">
				<h1>SƠ ĐỒ ĐƯỜNG ĐI & CHỈ DẪN</h1>
				<iframe title="map"
					src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d277.1304035601194!2d105.95617343116322!3d20.84755407092782!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjDCsDUwJzUxLjEiTiAxMDXCsDU3JzIyLjIiRQ!5e0!3m2!1svi!2s!4v1741235241242!5m2!1svi!2s"
					width="100%" height="360"></iframe>
			</div>
		</div>
        );
    }
};

export default Toptho;